import { translation, TranslatedComponent } from '@hh.ru/front-static-app';

import EmptyStateTemplate from 'src/components/EmptyState/EmptyStateTemplate';
import getDataQa from 'src/utils/getDataQa';

const TrlKeys = {
    title: 'career-platform.components.empty-state.courses.title',
};

const EmptyStateCourses: TranslatedComponent = ({ trls }) => {
    return <EmptyStateTemplate title={trls[TrlKeys.title]} data-qa={getDataQa('empty-state', 'courses')} />;
};
export default translation(EmptyStateCourses);
